import { Component, Input, OnDestroy, OnInit, Injectable} from '@angular/core';
import { BehaviorSubject, from, Observable, of, Subject, Subscription } from 'rxjs';
import { DocumentService } from '../_services/document.services';
import { HelperServices } from '../_services/helper.services';
import { catchError, exhaustMap, finalize } from 'rxjs/operators';
import { QuotesService } from '../_services/quotes2.services';
import { Document } from '../_models/document.model';
import { Quote, QuoteDocuments } from '../_models/quote.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import {NgbDateStruct, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import _, { map } from 'underscore';

const I18N_VALUES = {
    'fr': {
		weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
		months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    }
};

declare var download: any;
declare var require: any
const FileSaver = require('file-saver');

import {
	GroupingState,
	PaginatorState,
	SortState,
	ICreateAction,
	IEditAction,
	IDeleteAction,
	IDeleteSelectedAction,
	IFetchSelectedAction,
	IUpdateStatusForSelectedAction,
	ISortView,
	IFilterView,
	IGroupingView,
	ISearchView,
} from '../../_metronic/shared/crud-table';
import * as _moment from 'moment';

import {  CurrencyPipe, ViewportScroller } from '@angular/common';
import { validateAnyosPagos, validateTermino } from '../_helpers/customvalidator.validator';
import { Router } from '@angular/router';

@Component({
	selector: 'app-quotes',
	templateUrl: './quotes.component.html',
	styleUrls: ['./quotes.component.scss'],
	providers: [CurrencyPipe]
})

export class QuotesComponent implements
  	OnInit,
  	OnDestroy {
    loadingModalConfig: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
    };
    permissionMenu: any;
    VerEvaluacionCotizacionVida: boolean = false;
    loadingModal: boolean = false;
    paginator: PaginatorState;
    sorting: SortState;
    grouping: GroupingState;
    isLoading: boolean;
    templateView: number = 1;
    idQuote: number = 0;
    idDocument: number = 0;
    idEntity: number = 0;
    quote_selected: Quote;
    showComapnyName: boolean = false;
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user: UserModel;
    hasError: boolean;
    hasLoadindRD: boolean = false;
    isNewQuote: false;
    quoteHasError: boolean;
    genero:any;
    fumador:any;
    tipoPago:any;
    frecuenciaPago:any;
    estatus:any;
    tipoRiesgo:any;
    requiredDocument:any;
    filterQuoteForm: FormGroup;
    fileRequiredForm: FormGroup;
    quoteForm: FormGroup;
    quoteResult: any;
    quoteResult2: any;
    quoteHasSuccess : number = 2;
    closeResult: string;
    activeSubmitFilterQuote: boolean = false;
    
    public targetDiv1: ViewportScroller;
    private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    public isCollapsed1 = false; //Daypicker
    public isCollapsed2 = false; //Daypicker

    public quoteResultOb$: Observable<any>;
    private quoteResultSubject = new Subject<any>();

    public quoteHasError$: Observable<any>;
    public quoteHasErrorSubject = new Subject<any>();
    public cotizadorLink: any = "";

    constructor(
        private router: Router,
        public quoteService: QuotesService,
        public documentService: DocumentService,
        private layout: LayoutService,
        private auth: AuthService,
        private fb: FormBuilder,
        private modalRequiredDocumentos: NgbModal,
        private modalLoading: NgbModal,
        public sanitizer: DomSanitizer,
        public helperServices: HelperServices,
        public calendar: NgbCalendar,
        public currencyPipe : CurrencyPipe
    ) {}
  
    // angular lifecircle hooks
    async ngOnInit() {
        this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];
		this.user$ = this.auth.currentUserSubject.asObservable();
		this.user$.subscribe(user=> {
			this._user = user;
		});
		this.initForm();

		this.quoteResultOb$ = this.quoteResultSubject.asObservable();
		this.quoteHasError$ = this.quoteHasErrorSubject.asObservable();
		this.helperServices.getLinkCotizador().then(response => {
			if(response[0]) {
			  this.cotizadorLink = response[0].LinkCotizador;
			}
		});
		this.quoteService.fetch();
		this.genero = this.helperServices.getSexo();
		this.fumador = this.helperServices.getFumador();
		this.tipoRiesgo = this.helperServices.getTipoRiesgo();
    	this.frecuenciaPago = this.helperServices.getFrecuencia();
 	    this.estatus = this.quoteService.getStatus();
		this.extrasUserDropdownStyle = this.layout.getProp(
			'extras.user.dropdown.style'
		);

		this.paginator = this.quoteService.paginator;

		const sb1 = this.quoteService.isLoading$.subscribe(res => this.isLoading = res);
		this.subscriptions.push(sb1);
    }

    async clickView(id = 0, _templateView) {
      var _this = this;

      if(this.isNewQuote) {
        window.location.reload();
      }
      else {
        if(!id){
          return false;
        }
        
        else {
          switch ((this.templateView = _templateView)) {
            case 1:
              this.templateView = _templateView;
              await this.quoteService.patchState({ paramsGet : "" });
              this.quoteResultSubject.next(null);
              break;
            case 2:
              this.idQuote = id;
              var paramsGet = [];
              paramsGet.push(`NroCotizacion=${id}`);
              this.quote_selected = this.quoteService.extracData(this.idQuote, this.quoteService.items$);

              break;
          }
        }
      }
    }

    changeFilterMode(event) {
      this.filterQuoteForm = event.target.value;
    }
  
    initForm() {
        var g = this;

        this.quoteResult = {
        };

        this.filterQuoteForm = this.fb.group({
        inputNroCotizacion: [''],
        inputAsegurado: [''],
        inputFechaDesde: [''],
        inputFechaHasta: [''],
        inputEdad: ['',Validators.compose([Validators.pattern("^[0-9]*$")])],
        inputIdEstatus: [''],
        inputAgente: [''],
        inputGrupoEconomico: ['']
        });

        this.quoteForm = this.fb.group({
            inputIdCotizacion: [''],
            inputNroCotizacion: [''],
            inputAsegurado: ['', Validators.compose([Validators.required])],
        });
    }

    validInt(a) {
		if(a >= 0) {
			return parseInt(a);
		}
		return 0;
    }

    submitFilterQuote() {
		this.quoteService.patchState({ paramsGet : this.filterQuoteReport() });
    }

    filterQuoteReport() {
		var paramsGet = [];

		if( (this.filterQuoteForm.value.inputAsegurado)) {
			paramsGet.push(`Asegurado=${this.filterQuoteForm.value.inputAsegurado}`);
		}
		if( (this.filterQuoteForm.value.inputNroCotizacion) ) {
			paramsGet.push(`NroCotizacion=${this.filterQuoteForm.value.inputNroCotizacion}`);
		}
		/*
		if( (this.filterQuoteForm.value.inputEdad) ) {
			paramsGet.push(`Edad=${this.filterQuoteForm.value.inputEdad}`);
		}*/
		/*
		if(this.permissionMenu.VerEvaluacionCotizacionVida == 1 && this.filterQuoteForm.value.inputGrupoEconomico ) {
			paramsGet.push(`IdGrupoEconomico=${this.filterQuoteForm.value.inputGrupoEconomico}`);
		}*/
		if( (this.filterQuoteForm.value.inputIdEstatus) ) {
			paramsGet.push(`IdEstatus=${this.filterQuoteForm.value.inputIdEstatus}`);
		}
		if( typeof(this.filterQuoteForm.value.inputFechaDesde) == 'object' && this.filterQuoteForm.value.inputFechaDesde != null) {
			if(this.filterQuoteForm.value.inputFechaDesde.year){
				let date1 = Array(this.filterQuoteForm.value.inputFechaDesde.year, this.filterQuoteForm.value.inputFechaDesde.month,this.filterQuoteForm.value.inputFechaDesde.day).join('/')
				paramsGet.push(`FechaDesde=${date1}`);
			}
		}
		if( typeof(this.filterQuoteForm.value.inputFechaHasta) == 'object' && this.filterQuoteForm.value.inputFechaHasta != null) {
			if(this.filterQuoteForm.value.inputFechaHasta.year){
				let date2 = Array(this.filterQuoteForm.value.inputFechaHasta.year,this.filterQuoteForm.value.inputFechaHasta.month,this.filterQuoteForm.value.inputFechaHasta.day).join('/')
				paramsGet.push(`FechaHasta=${date2}`);
			}
		}
		/*
		if(this.permissionMenu.VerEvaluacionCotizacionVida == 1 && this.filterQuoteForm.value.inputAgente) {
			paramsGet.push(`Agente=${this.filterQuoteForm.value.inputAgente}`);
		}*/
		/*
		if(this.permissionMenu.VerEvaluacionCotizacionVida == 1 && this.filterQuoteForm.value.inputGrupoEconomico) {
			paramsGet.push(`Agente=${this.filterQuoteForm.value.inputGrupoEconomico}`);
		}*/

		return paramsGet.join('&');
	}


  ngOnDestroy() {
	this.subscriptions.forEach((sb) => sb.unsubscribe());
	this.quoteResultSubject.unsubscribe();
	this.quoteHasErrorSubject.unsubscribe();
  }
}